import { RefObject } from 'react';

export const getWebContentNodes = (selectorArr: string[] = []): (HTMLElement | null)[] =>
    selectorArr.map((selector) => document.querySelector(selector));

interface ITogglePosition {
    body: HTMLElement;
    element: HTMLElement | null;
    isHidden: boolean;
    position: number;
}

export const togglePosition = ({ body, element, isHidden, position }: ITogglePosition) => {
    if (!element) {
        return null;
    }

    element.classList.add('isFixed');
    element.style.top = isHidden
        ? `-${position}px`
        : `${position}px`;
    body.classList.toggle('menu-hidden', isHidden || false);
};

interface ResetPosition {
    body: HTMLElement;
    element: HTMLElement | null;
}

export const resetPosition = ({ element, body }: ResetPosition) => {
    if (!element) {
        return null;
    }

    element.classList.remove('isFixed');
    body.classList.toggle('menu-hidden', false);
};

interface HandleElementsPosition {
    body: HTMLElement;
    playBingoBtn?: HTMLElement;
    categoriesRef: RefObject<HTMLInputElement>;
    categoriesWrapperRef: HTMLElement | null;
    offsetTop: number;
    isHidden: boolean;
}

export const handleElementsPosition = ({
    body,
    playBingoBtn,
    categoriesRef,
    categoriesWrapperRef,
    offsetTop,
    isHidden
}: HandleElementsPosition) => {
    const CUSTOM_OFFSET_TOP = -220;

    if (!categoriesRef || !categoriesWrapperRef) {
        return null;
    }

    const shouldHide = categoriesWrapperRef.getBoundingClientRect().top <= CUSTOM_OFFSET_TOP && isHidden;

    if (Math.floor(categoriesWrapperRef.getBoundingClientRect().top) < Math.floor(offsetTop)) {
        togglePosition({
            body,
            element: categoriesRef.current,
            isHidden: shouldHide,
            position: offsetTop
        });

        playBingoBtn && togglePosition({
            body,
            element: playBingoBtn,
            isHidden: shouldHide,
            position: offsetTop + (categoriesRef.current?.clientHeight || 0)
        });
    } else {
        resetPosition({ element: categoriesRef.current, body });

        if (playBingoBtn) {
            resetPosition({ element: playBingoBtn, body });
        }
    }
};

interface HandleScroll {
    body: HTMLElement;
    playBingoBtn?: HTMLElement;
    categoriesRef: RefObject<HTMLInputElement>;
    categoriesWrapperRef: RefObject<HTMLInputElement>;
    headerHeight: number;
    prevPositionRef: {
        current: number;
    };
}

export const handleScroll = ({
    body,
    playBingoBtn,
    categoriesRef,
    categoriesWrapperRef,
    headerHeight,
    prevPositionRef
}: HandleScroll) => () => {
    const MIN_SCROLL = 5;

    const currentPosition = window.scrollY;
    const isHidden = prevPositionRef.current < currentPosition || !currentPosition;

    if (Math.abs(prevPositionRef.current - currentPosition) <= MIN_SCROLL) {
        return null;
    }

    if (!categoriesRef || !categoriesWrapperRef) {
        body.classList.remove('menu-hidden');
        return null;
    }

    handleElementsPosition({
        body,
        playBingoBtn,
        categoriesRef,
        offsetTop: headerHeight,
        isHidden,
        categoriesWrapperRef: categoriesWrapperRef?.current
    });

    prevPositionRef.current = currentPosition;
};
